import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

export interface EtapaKanbanExcluirDialogData {
  nomeEtapa: string;
  nomeProcesso: string;
  qtdMovimentacoesApontando: number;
}

export interface EtapaKanbanExcluirDialogResult {
  confirm: boolean;
}

/**
 * Confirmação da exclusão de uma etapa. Não há migração de documentos nem inativar: etapa com documento
 * não se exclui, e quem confere é a API (a recusa volta como aviso na tela de configuração).
 */
@Component({
  selector: 'app-etapa-kanban-excluir-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule],
  templateUrl: './etapa-kanban-excluir-dialog.component.html',
  styleUrls: ['./etapa-kanban-excluir-dialog.component.css'],
})
export class EtapaKanbanExcluirDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<EtapaKanbanExcluirDialogComponent, EtapaKanbanExcluirDialogResult>,
    @Inject(MAT_DIALOG_DATA) public data: EtapaKanbanExcluirDialogData
  ) {}

  public confirmar(): void {
    this.dialogRef.close({ confirm: true });
  }

  public cancelar(): void {
    this.dialogRef.close({ confirm: false });
  }
}
